var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.85455 1.5 1.5 4.85455 1.5 9C1.5 13.1455 4.85455 16.5 9 16.5C13.1455 16.5 16.5 13.1455 16.5 9C16.5 4.85455 13.1455 1.5 9 1.5ZM12.4091 9.00341C12.1416 9.26904 11.7095 9.26795 11.4433 9.00097L9.68182 7.23409V12.4091C9.68182 12.7856 9.37656 13.0909 9 13.0909C8.62344 13.0909 8.31818 12.7856 8.31818 12.4091V7.23409L6.55568 8.99659C6.29021 9.26206 5.85979 9.26206 5.59432 8.99659C5.32885 8.73112 5.32885 8.3007 5.59432 8.03523L8.40717 5.22238C8.73458 4.89497 9.26542 4.89497 9.59284 5.22238L12.4108 8.04034C12.6769 8.30648 12.6762 8.73821 12.4091 9.00341Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/upgrade.4462bdc4e890a9a227cd60d37c962db7.svg";
export { ForwardRef as ReactComponent };